<mat-form-field>
  <input #valueInput [matTooltip]="helpTooltip" matInput type="number" />
  <mat-icon class="clear-icon" [inline]="true" style="cursor: pointer" matSuffix (click)="resetValue()">
    {{ isValueEmpty ? "" : "close" }}
  </mat-icon>
  <mat-placeholder>{{ placeholder }}</mat-placeholder>
</mat-form-field>

<mat-form-field [matTooltip]="helpTooltip">
  <mat-select placeholder="UoM" #valueSelect (selectionChange)="selectedUnitOfMeasurementChanged($event)">
    <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions" [value]="measurementSystemOption.value">
      {{ measurementSystemOption.title }}
    </mat-option>
  </mat-select>
</mat-form-field>
